import $ from 'jquery';

export class LayoutFilter {
	constructor ($root) {
		this.$root = $root;
		this.$container = $('[data-layout-filter-container]');
		this.$items = this.$container.find('[data-layout-filter-item]');
		this.$controls = this.$root.find('[data-layout-filter-control]:not([data-tange-slider])');
		this.$rangeControls = this.$root.find('[data-layout-filter-control][data-range-slider]');
		this.classes = {
			hide: '_hide'
		};
		this.activeData = {};

		this.setActiveItems = (event) => {
			const $this = $(event.target);
			if (!$this.is('[data-range-slider]')) {
				if ($this.prop('checked')) {
					if (this.activeData[$this.data('layout-filter-control')] && !$this.closest('[data-select-box]').length) {
						this.activeData[$this.data('layout-filter-control')].data.push($this.val());
					} else {
						this.activeData[$this.data('layout-filter-control')] = {
							type: 'default',
							data: [$this.val()]
						};
					}
				} else {
					this.activeData[$this.data('layout-filter-control')] = {
						type: 'default',
						data: this.activeData[$this.data('layout-filter-control')].data.filter((val) => val !== $this.val())
					};
				}
			} else {
				let data = event.target.value.split(';');
				this.activeData[$this.data('layout-filter-control')] = {
					type: 'range',
					data: {
						from: Number(data[0]),
						to: Number(data[1])
					}
				};
			}
			const selector = $this.data('layout-filter-control');
			this.filterItems(selector);
		};

		this.setActiveItems.bind(this);
	}

	filterItems (selector) {
		this.$items.filter((i, el) => {
			const $el = $(el);
			const config = $el.data('layout-filter-item');
			let disabledBy = $el.data('disabled-by') ? JSON.parse($el.data('disabled-by')) : [];
			if (this.activeData[selector].type === 'range') {
				if (config[selector] >= this.activeData[selector].data.from && config[selector] <= this.activeData[selector].data.to) {
					if (disabledBy.includes(selector)) {
						this.showElement($el, disabledBy, selector);
					}
				} else {
					if (!disabledBy.includes(selector)) {
						this.hideElement($el, disabledBy, selector);
					}
				}
			} else {
				if (this.activeData[selector].data.includes(config[selector]) || !this.activeData[selector].data.length) {
					if (disabledBy.includes(selector)) {
						this.showElement($el, disabledBy, selector);
					}
				} else {
					if (!disabledBy.includes(selector)) {
						this.hideElement($el, disabledBy, selector);
					}
				}
			}
		});
	}

	hideElement ($element, disabledData, selector) {
		if (!disabledData.includes(selector)) {
			disabledData.push(selector);
			$element.attr('data-disabled-by', JSON.stringify(disabledData));
			$element.data('disabled-by', JSON.stringify(disabledData));
			$element.addClass(this.classes.hide);
		}
	}

	showElement ($element, disabledData, selector) {
		if (disabledData.includes(selector)) {
			if (disabledData.length) {
				disabledData = disabledData.filter((el) => {
					return el !== selector;
				});
			}
			$element.attr('data-disabled-by', JSON.stringify(disabledData));
			$element.data('disabled-by', JSON.stringify(disabledData));
			if (!disabledData.length) {
				$element.removeClass(this.classes.hide);
			}
		}
	}

	init () {
		this.$controls.on('change', this.setActiveItems);
		this.$rangeControls.on('change', this.setActiveItems);
	}
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_classes/LayoutFilter.js